import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SELECT_PAYMENT_PLAN,
  UPDATE_PROFILE,
  UPDATE_ATHLETE_PROFILE,
  UPDATE_COMPANY_INFO,
  SET_UNREAD_NOTIFICATION_COUNT, 
} from "../actions/authActions";

const initialState = {
  user: null,
  error: null,
  isAuthenticated: false,
  selectedPaymentPlan: null,
  profile_picture: null,
  profile_completed: false,
  company_logo: null,
  company_name: null,
  athlete_profile_completed: false,
  athlete_profile_picture: null,
  unreadNotificationCount: 0, 
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        error: null,
        profile_completed: action.payload?.profile_completed ?? state.profile_completed,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        userType: null,
        accessToken: null,
        isAuthenticated: false,
        error: action.payload,
      };
    case LOGOUT:
      return {
        ...initialState,
        error: null,
      };
    case SELECT_PAYMENT_PLAN:
      return {
        ...state,
        selectedPaymentPlan: action.payload,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        profile_picture: action.payload.profile_picture,
        profile_completed: action.payload.profile_completed,
      };
    case UPDATE_ATHLETE_PROFILE:
      return {
        ...state,
        athlete_profile_picture: action.payload.athlete_profile_picture,
        athlete_profile_completed: action.payload.athlete_profile_completed,
      };
    case UPDATE_COMPANY_INFO:
      return {
        ...state,
        company_logo: action.payload.logo,
        company_name: action.payload.name,
      };
      case SET_UNREAD_NOTIFICATION_COUNT:
        return {
          ...state,
          unreadNotificationCount: action.payload,
        };
    default:
      return state;
  }
};

export default authReducer;
